import React from "react";
import "./Style.css";
const Contact = () => {
    return (
        <>
            {/* <header className="front">
                <p>Gautam Juneja</p>
                <p>Data Structures</p>
                <p>java programmer</p>
                <p>Web Developer</p>
            </header>
            <header className="back">
                <p>+91 9817131893</p>
                <p>gautamjuneja864@gmail.com</p>
            </header> */}

            <div class="container1">
                <div class="card">

                    <div class="front side">
                        <h1 class="logo">Gautam Juneja</h1>
                    </div>

                    <div class="back side">
                        <h3 class="name">Gautam Juneja</h3>
                        <div>Front-end developer</div>
                        <div class="info">
                            <p><span class="property"></span>&nbsp;Email:&nbsp;&nbsp;   gautamjuneja864.com</p>
                            <p><span class="property"></span>&nbsp;LeetCode: &nbsp;&nbsp;  gau5tam</p>
                            <p><span class="property"></span>&nbsp;Twitter: &nbsp;&nbsp; @GautamJuneja17</p>
                            <p><span class="property"></span>&nbsp;Phone: &nbsp;&nbsp; +91 9817131893</p>
                            <p><span class="property"></span>&nbsp;Instagram:&nbsp;&nbsp;  juneja.goutam</p>
                            
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Contact;